/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Legal_DescriptionInputs */

const en_meta_legal_description = /** @type {(inputs: Meta_Legal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal and registration details for Lindevo — a trading name of Nauris Linde, a self-employed sole trader registered with the Latvian State Revenue Service.`)
};

const lv_meta_legal_description = /** @type {(inputs: Meta_Legal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lindevo juridiskā informācija un rekvizīti — Naura Lindes, Valsts ieņēmumu dienestā reģistrēta saimnieciskās darbības veicēja, zīmolvārds.`)
};

/**
* | output |
* | --- |
* | "Legal and registration details for Lindevo — a trading name of Nauris Linde, a self-employed sole trader registered with the Latvian State Revenue Service." |
*
* @param {Meta_Legal_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_legal_description = /** @type {((inputs?: Meta_Legal_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Legal_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_legal_description(inputs)
	return en_meta_legal_description(inputs)
});